import { url } from "./url_config";

export async function updateClientInfo(hwid, id, client_info, token) {
    try {
        const response = await fetch(`${url}devices/${hwid}?id=${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ client_info })
        });

        const data = await response.json();
        await new Promise(resolve => setTimeout(resolve, 750));

        if (!response.ok) {
            if (response.status === 400) {
                throw new Error("Comando inválido");
            } else {
                throw new Error(data.message || "Error de red");
            }
        }

        return data;

    } catch (e) {
        console.error("send command error:", e);
        throw e;
    }
}